<template>
  <div
    class="f-flex-shrink-0 f-w-6 f-h-6 f-grid f-place-content-center f-bg-gray-200 f-rounded-full f-cursor-pointer"
    @click="$emit('click', $event)"
  >
    <svg
      class="f-w-3 sm:f-w-4 f-text-gray-700"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M18 12H6"
      />
    </svg>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "MinusIcon",
});
</script>
